<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-7">
            <h5 class="card-title">{{ inspectionTitle }}</h5>
          </div>
          <div class="col-sm-5 pt-1 text-right">
          </div>
        </div>
      </div>
      <div class="card-body">
        <el-steps :active="activeElementIndex" finish-status="success" align-center>
          <el-step
            v-for="(elem, index) in elements"
            :key="elem.key"
            :status="elem.elementStatus === 'Abgeschlossen' ? 'success' : elem.elementStatus === 'In Arbeit' ? 'process' : 'wait'">
          </el-step>
        </el-steps>
        <div class="row text-center pt-4">
          <div class="col">
            <span style="font-size: 0.9em;" class="mt-2">Parcours</span>
            <h5>{{ parcoursName }}</h5>
          </div>
        </div>
        <div class="row text-center pt-0" v-if="elements.length && elements[activeElementIndex]">
          <div class="col">
            <span style="font-size: 0.9em;" class="mt-2">{{ elements[activeElementIndex].elementType }}</span>
            <h5>{{ elements[activeElementIndex].elementName }}</h5>
          </div>
        </div>
        <div class="row text-center pt-0" v-if="elements.length && elements[activeElementIndex] && elements[activeElementIndex].elementChecks && elements[activeElementIndex].elementChecks.length > 0">
          <div class="col">
            <span style="font-size: 0.9em;" class="mt-2">Prüfkriterien</span>
            <div class="mt-2">
              <el-checkbox-group v-model="elements[activeElementIndex].elementChecksChecked" class="">
                <el-checkbox
                  v-for="check in elements[activeElementIndex].elementChecks"
                  :key="check.key"
                  size="medium"
                  :label="check.checkText"
                  :disabled="false"
                  class="d-block pb-1 mr-0">
                  {{ check.checkText }}
                </el-checkbox>
              </el-checkbox-group>
            </div>


                

          </div>
        </div>
        <div class="row text-center pt-0 justify-content-around" v-if="elements.length && elements[activeElementIndex]">
          <div class="col-sm-6">
            <p-button block type="primary" size="lg" v-if="elements[activeElementIndex].elementDefectsCount == 0" @click="nextElement()" class="mt-3">Prüfung OK</p-button>
            <p-button block type="warning" size="lg" v-if="elements[activeElementIndex].elementDefectsCount > 0" @click="nextElement()" class="mt-3">Keine weiteren Mängel</p-button>
            <p-button block type="danger" size="lg" @click="addDefect()" class="mt-3">Mangel erfassen</p-button>
          </div>
        </div>
        <div class="row text-center pt-4 justify-content-around" v-if="elements.length && elements[activeElementIndex]">
          <div class="col-sm-6">
            <h6>Bekannte Mängel:</h6>
            <span v-if="elements[activeElementIndex].elementDefectsCount == 0" class="text-success"><i>Keine bekannten Mängel.</i></span>
            <ul v-else class="list-unstyled">
              <li v-for="defect in elements[activeElementIndex].elementDefects" :key="defect.key" @click="showDefect(defect)" style="cursor: pointer;" class="pb-1">
                <span class="text-danger"><b>{{ defect.defectTitle }}</b></span> <span> ({{ defect.defectDate }})</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="row text-center pt-2 justify-content-around" v-if="elements.length && elements[activeElementIndex]">
          <div class="col-sm-6">
            <span class="text-muted" v-if="elements[activeElementIndex].elementDefectsCount > 0"><i>Bereits bekannte Mängel müssen nicht erneut erfasst werden.</i></span>
          </div>
        </div>
        <div class="row text-center pt-4 justify-content-around">
          <div class="col-sm-6">
            <p-button block type="default" size="" @click="backToInspections()" class="mt-3">Zurück zur Übersicht</p-button>
          </div>
        </div>
      </div>
    </div>

    <modal :show.sync="showDefectModal" headerClasses="justify-content-center">
      <h5 slot="header" class="title mb-0">{{ selectedDefect.defectTitle }}</h5>
      <div class="row">
        <div class="col">
          <label class="pt-0 pr-2"><b>Parcours:</b></label>
          <span>{{ parcoursName }}</span>
        </div>
        <div class="col">
          <label class="pt-0 pr-2"><b>Element:</b></label>
          <span v-if="elements.length && elements[activeElementIndex]">{{ elements[activeElementIndex].elementName }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-1"><b>Beschreibung:</b></label>
          <p>{{ selectedDefect.defectDescription }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-1 pr-2"><b>Priorität:</b></label>
          <span>{{ selectedDefect.defectPrio }}</span>
        </div>
        <div class="col">
          <label class="pt-1 pr-2"><b>Status:</b></label>
          <span>{{ selectedDefect.defectStatus }}</span>
        </div>
      </div>
      <div class="row" v-if="selectedDefect.defectPhotos && selectedDefect.defectPhotos.length > 0">
        <div class="col">
          <label class="pt-2"><b>Fotos:</b></label>
          <div class="row">
            <div class="col-sm-4 mb-3" v-for="(photo, index) in selectedDefect.defectPhotos" :key="index">
              <img :src="photo" class="img-fluid rounded">
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import { Table, TableColumn, Input, Loading, Popover, Tag, Select, Option, Progress, Steps, Step, CheckboxGroup } from "element-ui";
import { Modal } from "src/components/UIComponents";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Loading);
Vue.use(Tag)

export default {
  components: {
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Progress.name]: Progress,
    [Steps.name]: Steps,
    [Step.name]: Step,
    Modal,
    [CheckboxGroup.name]: CheckboxGroup,
  },

  data() {
    return {
      loading: true,
      role: store.getters.userrole,
      location: store.getters.userlocation,
      user: store.getters.user.data.displayName,
      inspectionId: "",
      parcoursId: "",
      elements: [],
      inspectionStatus: "",
      inspectionTitle: "",
      parcoursName: "",
      activeElementIndex: 0,
      showDefectModal: false,
      selectedDefect: "",
    };
  },
  created() {
    moment.locale("de");
    this.inspectionId = this.$route.params.inspectionId;
    this.parcoursId = this.$route.params.parcoursId;
    this.loadInspection();
  },
  methods: {
    loadInspection() {
      // get inspection data from firebase
      const inspectionRef = db.collection("constructionInspections").doc(this.inspectionId);
      inspectionRef.onSnapshot((snapshotChange) => {
        const inspectionData = snapshotChange.data();
        this.inspectionStatus = inspectionData.Status;
        this.inspectionTitle = inspectionData.Title;
        // get parcours data
        const parcoursRef = inspectionRef.collection("parcours").doc(this.parcoursId);
        parcoursRef.onSnapshot((parcoursSnap) => {
          const parcoursData = parcoursSnap.data();
          this.parcoursName = parcoursData.Name;
          // get elements data
          const elementsRef = parcoursRef.collection("elements");
          elementsRef.orderBy("elementPosition").onSnapshot((elementsSnapshot) => {
            this.elements = [];
            let elementIndex = 0;
            elementsSnapshot.forEach((elemDoc) => {
              const elemData = elemDoc.data();
              if (elemData.elementStatus === 'Abgeschlossen') {
                this.activeElementIndex = elementIndex + 1;
              } 
              const defectsRef = db.collection("constructionDefects");
              const elementDefects = [];
              defectsRef.where('Parcours', '==', this.parcoursName).where('Element', '==', elemData.elementName).where('Status', '!=', 'Erledigt')
                .onSnapshot((defectsSnapshot) => {
                  defectsSnapshot.forEach((defectDoc) => {
                    elementDefects.push({
                      key: defectDoc.id,
                      defectTitle: defectDoc.data().Title,
                      defectPrio: defectDoc.data().Prio,
                      defectDate: moment(new Date(defectDoc.data().Date.seconds * 1000)).format("DD.MM.yyyy").toString(),
                      defectStatus: defectDoc.data().Status,
                      defectDescription: defectDoc.data().Description,
                      defectPhotos: defectDoc.data().Photos,
                    });
                  });
                  this.elements.push({
                    key: elemDoc.id,
                    elementName: elemData.elementName,
                    elementStatus: elemData.elementStatus,
                    elementPosition: elemData.elementPosition,
                    elementType: elemData.elementType,
                    elementChecks: elemData.elementChecks || [],
                    elementChecksChecked: elemData.elementChecksChecked || [],
                    elementDefects: elementDefects,
                    elementDefectsCount: elementDefects.length,
                    elementDefectsAdded: 0,
                  });

                });
              elementIndex++;
            });
            this.loading = false;
          });
        });
      });
    },
    showDefect(defect) {
      this.selectedDefect = defect;
      this.showDefectModal = true;
    },
    backToInspections() {
      router.push({ name: 'Inspections', params: { inspectionId: this.inspectionId } });
    },
    nextElement() {
      // update element status to 'Abgeschlossen' in firebase
      const inspectionRef = db.collection("constructionInspections").doc(this.inspectionId);
      const parcoursRef = inspectionRef.collection("parcours").doc(this.parcoursId);
      const elementRef = parcoursRef.collection("elements").doc(this.elements[this.activeElementIndex].key);
      elementRef.update({
        elementStatus: 'Abgeschlossen',
        elementPruefer: this.user,
      }).then(() => {
        if (this.activeElementIndex <= this.elements.length - 1) {
          // move to next element
        } else {
          // update parcorus status to 'Abgeschlossen' in firebase
          parcoursRef.update({
            Status: 'Abgeschlossen',
          }).then(() => {
            // all elements checked, go back to inspections overview
            router.push({ name: 'Inspections', params: { inspectionId: this.inspectionId, parcoursNameDone: this.parcoursName } });
          }).catch((error) => {
            console.error("Error updating parcours status: ", error);
          });          
        }
      }).catch((error) => {
        console.error("Error updating element status: ", error);
      });
      
    },
    addDefect() {
      router.push({ name: 'DefectDetails', params: { inspectionId: this.inspectionId, parcoursName: this.parcoursName, parcoursId: this.parcoursId, elementName: this.elements[this.activeElementIndex].elementName, mode: 'new' } });
    },
  },
};
</script>
<style scoped>
::v-deep .el-checkbox__label {
  font-size: 1.2rem !important;
  
}
::v-deep .el-checkbox__input {
  vertical-align: baseline !important;
}
</style>
